import Job from '../Job';
import { IContact } from '@leedpulse-monorepo/interfaces';

export default class JobWithContact {
  private _job: Job;
  private _contact: IContact;

  constructor(job: Job, contact: IContact) {
    this._job = job;
    this._contact = contact;
  }

  get job(): Job {
    return this._job;
  }

  get contact(): IContact {
    return this._contact;
  }

  // Getters to display on the lists
  get id(): string {
    return this._job.id;
  }
  get contactFullname(): string {
    return this._contact.contact.firstname + ' ' + this._contact.contact.lastname;
  }
  get contactFirstname(): string {
    return this._contact.contact.firstname;
  }
  get contactLastname(): string {
    return this._contact.contact.lastname;
  }
  get timestamp(): Date {
    return this._job.timestamp;
  }
  get type(): string {
    return this._job.type;
  }
}
